import {css} from '@emotion/react'

export const colors = {
    blue: '#2500D3',
    red: '#f41a00',
}

export const type = {
    larish: `'Larish Alte Semibold', 'Palatino Linotype', Palatino, Baskerville, Garamond, Georgia, serif`,
    steps: `'Steps Mono', 'Andale Mono', Monaco, Courier, monospace`,
    favorit: `'Favorit Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
}

export const hidden = css`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`

export const outline = (color) => css`
    @supports (-webkit-text-stroke: 1px ${color}) {
        -webkit-text-stroke: 1px ${color};
        color: transparent;
    }
`

export const media = (width, styles) => css`
    @media (min-width: ${width}px) {
        ${styles}
    }
`

export const global = css`
    * {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body {
        font-family: ${type.favorit};
        margin: 0;
        background-color: ${colors.blue};
        color: #fff;
    }

    a {
        color: #fff;

        &:hover,
        &:active,
        &:focus {
            color: ${colors.blue};
        }
    }

    p,
    ul {
        line-height: 1.8;
        margin: 0 auto 2rem;
    }

    h1,
    h2,
    h3,
    h4 {
        font-family: ${type.larish};
        font-weight: 200;
        line-height: 1.4;
    }

    h1,
    h2,
    h3 {
        color: #fff;
    }

    h1,
    h2 {
        font-size: 2.6rem;
        letter-spacing: -1.5px;

        @media (min-width: 1080px) {
            font-size: 4rem;
        }
    }

    h2 {
        margin-top: 8rem;
    }

    h3 {
        font-size: 2rem;
        letter-spacing: -0.8px;
        margin: 4rem 0 1rem;

        @media (min-width: 800px) {
            font-size: 2.6rem;
        }
    }

    h4 {
        font-size: 1.5rem;
        letter-spacing: -0.8px;
        margin: 4rem 0 1rem;
    }

    ul {
        padding: 0;
    }
`
